import dict from 'locales/dict';
import { useTranslation } from 'react-i18next';
import { MotionDiv } from './motion-div';
import { ImageVideo } from 'shared/interfaces';
import { useInView } from 'hooks';
import { useState } from 'react';
import { getThumbnailSrc } from 'utils/image-helper';

interface Props {
  image: ImageVideo;
  delay?: number;
  showView?: boolean;
  className?: string;
  onClick?: () => void;
}

export function MotionImage({ image, delay, showView, className, onClick }: Props) {
  const { t } = useTranslation();
  const [isThumbError, setIsThumbError] = useState(false); // Trạng thái lỗi ảnh thumb
  const [isLoaded, setIsLoaded] = useState(false); // Trạng thái ảnh đã tải xong

  const { ref, isInView } = useInView<HTMLDivElement>({
    threshold: 0.1,
    rootMargin: '300px', // preload sớm 300px
  });

  const thumbSrc = getThumbnailSrc(image?.src);

  return (
    <MotionDiv
      ref={ref}
      className='group relative flex flex-col-reverse z-1 hover:z-10'
      delay={delay}
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.3 }}
    >
      {image?.caption && <div className='absolute inset-0 flex items-end p-4'>{image.caption}</div>}

      {/* IMAGE */}
      <div className='aspect-square w-full rounded-md bg-gray-200 lg:h-60 overflow-hidden'>
        {/* Placeholder hoặc Loading Spinner (tùy chọn) */}
        {!isLoaded && !isThumbError && isInView && <div className='absolute inset-0 bg-gray-300 animate-pulse' />}

        {isInView ? (
          // <img
          //   alt={image?.src}
          //   src={image?.src}
          //   className={`h-full w-full object-cover transition-opacity duration-300 group-hover:opacity-75 ${className} ${
          //     onClick ? 'cursor-pointer' : ''
          //   }`}
          //   onClick={onClick}
          // />
          isThumbError ? (
            // HIỂN THỊ LỖI KHI KHÔNG CÓ THUMBNAIL
            <span className='text-xs text-red-500 font-medium p-2 text-center'>Missing Thumbnail: {image?.src}</span>
          ) : (
            <img
              alt={image?.src}
              src={thumbSrc} // Dùng đường dẫn THUMBNAIL
              loading='lazy'
              onLoad={() => setIsLoaded(true)} // Khi ảnh tải xong mới set
              onError={() => setIsThumbError(true)} // Nếu load lỗi thì set state
              className={`h-full w-full object-cover transition-opacity duration-300 group-hover:opacity-75
                ${className}
                ${isLoaded ? 'opacity-100' : 'opacity-0'}
                ${onClick ? 'cursor-pointer' : ''}`}
              onClick={onClick} // Click vẫn dùng hàm onClick cũ để mở ảnh gốc
            />
          )
        ) : null}
      </div>

      {showView && (
        <div className='absolute inset-0 flex items-end p-4'>
          <button
            type='button'
            className='relative z-10 w-full rounded-md bg-white/75 px-4 py-2 text-sm text-gray-900 cursor-pointer'
            onClick={onClick}
          >
            {t(dict.view)}
          </button>
        </div>
      )}
    </MotionDiv>
  );
}
